import * as React from 'react';
import { CustomerUtils } from '~/connect/helpers';
import { useCustomerFormPrivileges } from '~/connect/hooks';

export const useCustomerFormStepper = ({
  onSubmit,
  customerLevel,
}: {
  onSubmit: () => void;
  customerLevel: number;
}) => {
  const [activeStep, setActiveStep] = React.useState(
    CustomerUtils.GENERAL_FORM_STEP,
  );
  const CustomerFormPrivileges = useCustomerFormPrivileges({
    level: customerLevel,
  });
  const handlers = React.useMemo(
    () => ({
      set: (target: number) => setActiveStep(target),
      onNext: () => {
        if (
          activeStep <
          CustomerUtils.getAuthorizedSteps(CustomerFormPrivileges).length - 1
        ) {
          setActiveStep((prev) => prev + 1);
        } else {
          onSubmit();
        }
      },
      onPrevious: () => {
        setActiveStep((prev) => prev - 1);
      },
    }),
    [activeStep, onSubmit, CustomerFormPrivileges],
  );

  return [activeStep, handlers] as const;
};
